import { useQuery } from '@tanstack/react-query';
import { agendaRecommendationsApi } from 'screens/oneOnOneRabbit/InstancePage/apis';
import { oneOneOneReactQueryKeys } from 'screens/oneOnOneRabbit/InstancePage/constants/oneOnOneReactQueryKeys';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import { LibraryTypeI } from '../interface';
import { getOneOnOneAgendaLibrary, getOneOnOneAgendaLibraryForSettings } from '../services';

export const useOneOnOneAgendaLibraryQuery = ({
  masterId,
  instanceId,
  type,
  enabled = false,
}: OneOnOneRequestI &
  LibraryTypeI & {
    enabled?: boolean;
  }) =>
  useQuery(
    [oneOneOneReactQueryKeys.oneOnOneAgendaLibrary, masterId, instanceId, type],
    () => getOneOnOneAgendaLibrary({ masterId, instanceId, type }),
    {
      enabled,
    }
  );

export const useOneOnOneAgendaLibraryForSettingsQuery = ({
  type,
  enabled = false,
}: LibraryTypeI & {
  enabled?: boolean;
}) =>
  useQuery(
    [oneOneOneReactQueryKeys.oneOnOneAgendaLibrary, 'isSettingsPage', type],
    () => getOneOnOneAgendaLibraryForSettings({ type }),
    {
      enabled,
    }
  );

export const useAgendaRecommendationsApiQuery = ({ masterId, instanceId }) =>
  useQuery(
    [oneOneOneReactQueryKeys.agendaRecommendationsApi, masterId, instanceId],
    () => {
      const data = agendaRecommendationsApi({ masterId, instanceId }).then((res) => res.entity);
      return data ?? [];
    },
    {
      enabled: !!masterId,
    }
  );
